export enum LogicalOperator {
    AND = '&&',
    OR = '||'
}
